class PmallCheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.container = this.closest(".pmall-checkout-btn");
    this.form = this.closest("form");
    this.button = this.querySelector("[type=submit]");
    this.cartCloseButton = document.querySelector(
      ".cart--root .drawer-close-button"
    );
    this.errorModalTrigger = document.querySelector(
      '[data-trigger="fatal-error-modal"]'
    );
    this.load();
  }

  setLoading(isLoading) {
    isLoading
      ? this.container.classList.add("form-loading")
      : this.container.classList.remove("form-loading");
  }

  getSubInterval(item, payloadItem) {
    if (item.properties && item.properties._interval) {
      payloadItem.interval = item.properties._interval;
    }
  }

  createOrderItems(cartItems = []) {
    return cartItems.map((item) => {
      const payloadItem = {
        quantity: item.quantity,
        variant: item.variant_id,
      };
      this.getSubInterval(item, payloadItem);
      return payloadItem;
    });
  }

  createOrder(cartData) {
    return apiFetchPmallStoreFront("/api/pmall-checkout/order", "POST", {
      country: theme.cart.country_code,
      currency: cartData.currency,
      items: this.createOrderItems(cartData.items),
      meta: getCapiData(),
    });
  }

  handleError(errData) {
    this.setLoading(false);
    this.cartCloseButton.click();
    this.errorModalTrigger.click();
    logger.error(errData);
  }
  processCheckout(evt) {
    evt.preventDefault();
    this.setLoading(true);

    apiFetchJson("", "/cart.js")
      .then((cartData) => {
        return this.createOrder(cartData);
      })
      .then((res) => {
        if (res.isError) {
          this.handleError(res);
        } else {
          const override_url = this.getCheckoutURLQueryParams();
          window.location.assign(
            `${theme.settings.pmall_checkokut_url}/${res.result.cart_hash}${override_url}`
          );
        }
      })
      .catch((err) => {
        this.handleError(err);
      });
  }
  getCheckoutURLQueryParams () {
    const discount_code = getCookie("selected_promo_code") || "";
    return discount_code ? `?override_coupon=${discount_code}` : '';
  }
  load() {
    // Use the form submit event if button is placed inside a form
    if (this.form) {
      this.form.addEventListener("submit", (evt) => this.processCheckout(evt));
    } else {
      this.button.addEventListener("click", (evt) => this.processCheckout(evt));
    }
  }
}

customElements.define("pmall-checkout-button", PmallCheckoutButton);
